(function ($) {

    // ── Veřejné API ──────────────────────────────────────────────
    window.ModalManager = {

        /**
         * Otevře modal — buď z HTML stringu nebo načtením URL.
         * @param {string} source  - HTML string nebo URL
         * @param {boolean} isUrl  - true = načíst přes AJAX, false = přímý HTML
         * @param {boolean} replaceContentOnly - true = ponechat otevřený modal a vyměnit jen jeho obsah
         */
        open: function (source, isUrl, replaceContentOnly) {
            var $modal = $('#modal');

            if (replaceContentOnly && $modal.length && $modal.hasClass('show')) {
                isUrl ? _loadFromUrl(source, true) : _replaceHtml(source);
                return;
            }

            if ($modal.length && $modal.hasClass('show')) {
                $modal.one('hidden.bs.modal', function () {
                    $(this).remove();
                    isUrl ? _loadFromUrl(source) : _renderHtml(source);
                });
                bootstrap.Modal.getOrCreateInstance($modal[0]).hide();
            } else {
                $modal.remove();
                isUrl ? _loadFromUrl(source) : _renderHtml(source);
            }
        },

        close: function () {
            var $modal = $('#modal');
            if ($modal.length) {
                bootstrap.Modal.getOrCreateInstance($modal[0]).hide();
            }
        },

        replace: function (source, isUrl) {
            this.open(source, isUrl, true);
        }
    };

    // ── Privátní funkce ──────────────────────────────────────────
    function _initTooltips(root) {
        var selector = '[data-bs-toggle="tooltip"]';
        var elements = [];

        if (!root || !window.bootstrap || !window.bootstrap.Tooltip) {
            return;
        }

        if (root.matches && root.matches(selector)) {
            elements.push(root);
        }

        elements = elements.concat(Array.from(root.querySelectorAll ? root.querySelectorAll(selector) : []));

        elements.forEach(function (element) {
            window.bootstrap.Tooltip.getOrCreateInstance(element);
        });
    }

    function _renderHtml(html) {
        $('body').append(html);
        _initTooltips(document.getElementById('modal'));
        $('#modal').modal('show');
    }

    function _replaceHtml(html) {
        var $currentModal = $('#modal');
        var $nextModal = $(html).filter('#modal').first();
        var currentAttributes;

        if (!$nextModal.length) {
            $nextModal = $(html).find('#modal').first();
        }

        if (!$currentModal.length || !$nextModal.length) {
            _renderHtml(html);
            return;
        }

        currentAttributes = {
            className: $currentModal.attr('class') || '',
            style: $currentModal.attr('style') || '',
            ariaModal: $currentModal.attr('aria-modal'),
            role: $currentModal.attr('role')
        };

        $.each($currentModal[0].attributes, function () {
            if (this && this.name !== 'id') {
                $currentModal.removeAttr(this.name);
            }
        });

        $.each($nextModal[0].attributes, function () {
            if (this && this.name !== 'id') {
                $currentModal.attr(this.name, this.value);
            }
        });

        $currentModal
            .attr('class', _mergeModalClasses($nextModal.attr('class') || '', currentAttributes.className))
            .attr('style', currentAttributes.style)
            .attr('aria-hidden', 'false');

        if (currentAttributes.ariaModal) {
            $currentModal.attr('aria-modal', currentAttributes.ariaModal);
        } else {
            $currentModal.removeAttr('aria-modal');
        }

        if (currentAttributes.role) {
            $currentModal.attr('role', currentAttributes.role);
        }

        $currentModal.html($nextModal.html());
        _initTooltips($currentModal[0]);
    }

    function _mergeModalClasses(nextClassName, currentClassName) {
        var classes = (nextClassName + ' ' + currentClassName).split(/\s+/);
        var uniqueClasses = [];

        $.each(classes, function (_, className) {
            if (className && $.inArray(className, uniqueClasses) === -1) {
                uniqueClasses.push(className);
            }
        });

        return uniqueClasses.join(' ');
    }

    function _loadFromUrl(url, replaceContentOnly) {
        $.ajax({
            url: url,
            dataType: 'html',
            success: function (html) {
                try {
                    var json = JSON.parse(html);
                    if (json['success']) {
                        if (json['data']['html']) {
                            replaceContentOnly ? _replaceHtml(json['data']['html']) : _renderHtml(json['data']['html']);
                        }
                    } else {
                        if (typeof json['data']['message'] === 'string') {
                            $('#alert').prepend(
                                '<div class="alert alert-danger alert-dismissible">' +
                                '<i class="fa-solid fa-circle-exclamation"></i> ' +
                                json['data']['message'] +
                                ' <button type="button" class="btn-close" data-bs-dismiss="alert"></button>' +
                                '</div>'
                            );
                        }
                    }
                } catch (e) {
                    replaceContentOnly ? _replaceHtml(html) : _renderHtml(html);
                }
            }
        });
    }

    // ── Click handler (beze změny logiky) ────────────────────────
    $(document).on('click', 'a[data-bs-toggle="modal"], a[data-wp-toggle="modal"]', function (e) {
        e.preventDefault();
        ModalManager.open($(this).attr('href'), true, true);
    });

})(jQuery);
